import React from 'react'

const SalesAndReport = () => {
    return <></>
}
export default SalesAndReport
